// extracted by mini-css-extract-plugin
module.exports = {"container":"fp","modal":"gp"};